module.exports = __webpack_public_path__ + "static/colgadas-005.thumb-887c6efbca442e2cc3b93e821ab800ba.jpg";